import React, {useEffect, useState} from 'react';
import {useClienteDsCloud} from '../hooks/useClienteDsCloud';
import {Button, Container, Grid, Typography} from '@mui/material';
import {makeStyles} from 'tss-react/mui';
import {ClienteDsCloud} from '../../bussines/entities/clienteDsCloud.enity';
import {DataTable} from '../components/DataTable';
import {format} from 'date-fns';
import {ConfirmDialog, toast} from 'lib.front';
import {paramsSetEstadoCuentaPorSuscrip} from '../../bussines/params/ClienteDsCloud.params';
import {AlertDialog} from '../components/AlertDialog';

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   input: {
      maxWidth: '500px',
   }
}));

const AdminClientDsCloud: React.FC = () => {
   const {classes, cx} = useStyles();
   const [dataTableClientes, setDataTableClientes] = useState<ClienteDsCloud[]>([]);
   const {getClientesDsCloud, setEstadoCuentaPorSuscrip} = useClienteDsCloud();
   const [openConfirmD, setOpenConfirmD] = useState(false);
   const [clienteSuscrip, setClienteSuscrip] = useState<paramsSetEstadoCuentaPorSuscrip | null>(
      null
   );
   const fetchClientesDsCloud = async () => {
      const result = await getClientesDsCloud({});
      if (result) setDataTableClientes(result);
   };
   const fechChangeEstadoCuentaPorSus = async () => {
      if (clienteSuscrip) {
         const result = await setEstadoCuentaPorSuscrip(clienteSuscrip);
         console.log("result: ", result);
         toast.showSucces(result);
      }
   };

   const handleOnConfirm = async () => {
      await fechChangeEstadoCuentaPorSus();
      setClienteSuscrip(null);
      fetchClientesDsCloud();
   }

   const handleOnCancel = () => {
      setClienteSuscrip(null);
      setOpenConfirmD(false);
   }

   useEffect(() => {
      fetchClientesDsCloud();
   }, []);

   const column = [
      {
         name: 'codigoCliente',
         label: 'Codigo Cliente',
         options: {
            sort: true,
            display: true
         }
      },
      {
         name: 'denominacionCliente',
         label: 'Cliente',
         options: {
            sort: true,
            display: true
         }
      },
      {
         name: 'fechaExpiracion',
         label: 'Fecha Expiracion',
         options: {
            sort: true,
            display: true,
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
               const fecha = new Date(value);
               return format(fecha, 'dd/MM/yyyy');
            }
         }
      },
      {
         name: 'esDemo',
         label: 'Demo',
         options: {
            sort: true,
            display: true,
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
               return value ? 'Si' : 'No';
            }
         }
      },
      {
         name: 'idCuenta',
         label: 'Cuenta',
         options: {
            sort: true,
            display: true
         }
      },
      {
         name: 'denominacionPlan',
         label: 'Plan',
         options: {
            sort: true,
            display: true
         }
      },
      {
         name: 'idSuscripcion',
         label: 'Suscripción',
         options: {
            sort: true,
            display: true
         }
      },
      {
         name: 'cuentaSuscripcionActivo',
         label: 'Estado Suscripción',
         options: {
            sort: true,
            display: true,
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
               const esActivo = Boolean(value);
               return (
                  <Button
                     variant="contained"
                     color={esActivo ? 'success' : 'error'}
                     onClick={() => {
                        setOpenConfirmD(true);
                        setClienteSuscrip({
                           codigoCliente: tableMeta.rowData[0],
                           idSuscripcion: tableMeta.rowData[6],
                           estado: !esActivo
                        });
                     }}
                  >
                     {Boolean(value) ? 'Activo' : 'Desactivo'}
                  </Button>
               );
            }
         }
      }
   ];

   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="lg">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Administración del Clientes del DsCont Cloud
               </Typography>
            </Grid>
            <Grid item xs={12}>
               <DataTable columns={column} data={dataTableClientes} />
            </Grid>
            <AlertDialog
               titulo={`Esta seguro de que quiere ${
                  clienteSuscrip?.estado ? 'activar' : 'desactivar'
               } las cuentas asociadas al cliente ${clienteSuscrip?.codigoCliente} y suscripcion ${
                  clienteSuscrip?.idSuscripcion
               }?`}
               openConfirmD={openConfirmD}
               setOpenConfirmD={setOpenConfirmD}
               onConfirm={handleOnConfirm}
               onCancel={handleOnCancel}
            />
         </Grid>
      </Container>
   );
};

export default AdminClientDsCloud;
